import FeatureSection from "../components/FeatureListSection";
import { useAuth } from "../hooks/useAuth";

export default function Features() {
  const { user } = useAuth();

  return (
    <div className="flex grow flex-col items-center">
      {/* Features */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <FeatureSection pageSize={7} />
      </div>
    </div>
  );
}
